module.exports = function() {
	return new Worker(__webpack_public_path__ + "5e3c304ea87541cabdab.worker.js");
};


//////////////////
// WEBPACK FOOTER
// /~/worker-loader!/~/eoxc/src/search/opensearch/OpenSearchWorker.js
// module id = 2273
// module chunks = 0